import { Content } from './zone.styled';

/**
 * Parse a CSS color (#rgb, #rrggbb or rgb()/rgba()) into {r,g,b}.
 * Returns null for anything we can't read.
 */
const parseColor = (color) => {
  if (!color || typeof color !== 'string') {
    return null;
  }
  const c = color.trim();
  if (c[0] === '#') {
    let hex = c.slice(1);
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
      return null;
    }
    const num = parseInt(hex, 16);
    if (Number.isNaN(num)) {
      return null;
    }
    return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
  }
  const m = c.match(/rgba?\(([^)]+)\)/i);
  if (m) {
    const parts = m[1].split(',').map((p) => parseFloat(p));
    return { r: parts[0], g: parts[1], b: parts[2] };
  }
  return null;
};

/**
 * Pick a legible text color for a given zone background.
 * Uses perceived luminance so the zone id stays readable on any color.
 */
const getContrastText = (color) => {
  const rgb = parseColor(color);
  if (!rgb) {
    return '#ffffff';
  }
  const lum = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
  return lum > 0.62 ? '#12181c' : '#ffffff';
};

export const Zone = (props) => {
  const { color, zoneId, ...rest } = props;
  const textColor = getContrastText(color);

  return (
    <Content className="zone-icon" style={{ backgroundColor: color }} $text={textColor} {...rest}>
      <b>{zoneId}</b>
    </Content>
  );
};
